import { I18nComponente } from "@/types/gerais"

export const MListaDeGruposi18n: I18nComponente = {
  "pt-BR": {
    gruposDeProjetos: "grupos de projetos",
  },
  "es-CO": {
    gruposDeProjetos: "grupos de proyectos",
  }
}
